import { useEffect } from "react";

export const SplashScreen = ({ setLoading, hide }) => {

    useEffect(() => {
        const hasVisited = sessionStorage.getItem("hasVisited");

        if (hasVisited) {
            setLoading(false); // Skip splash screen
        } else {
            sessionStorage.setItem("hasVisited", "true"); // Set flag
            setTimeout(() => {
                setLoading(false);
            }, 4500); // Show splash for 2s
        }
    }, []);

    return (
        <div className={`splash-container ${hide ? "hidden" : ""} flex items-center flex-col gap-3 justify-center h-screen bg-primary text-white text-xl`}>
            <div className="flex justify-center mb-8">
                <div className="flex items-center gap-4 animate-bounce">
                    <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center transform rotate-12 shadow-2xl">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                    </div>
                    <h1 className="text-4xl font-bold bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent">
                        Gro Wing CRM
                    </h1>
                </div>
            </div>
        </div>
    );
};